export default {
    series: [
        {
            type: 'treemap',
            name: 'Partnerships Heatmap',
            allowTraversingTree: true,
            alternateStartingDirection: true,
            dataLabels: {
                style: {
                    textOutline: 'none'
                }
            },
            borderRadius: 0,
            borderWidth: 3,
            borderColor: "#fff",
            levels: [
                {
                    borderColor: "lightgrey",
                    borderWidth: 1,
                    level: 1,
                    layoutAlgorithm: 'squarified',
                    groupPadding: 3,
                    dataLabels: {
                        headers: true,
                        enabled: true,
                        useHTML: true,
                        allowOverlap: false,

                        formatter: function () {
                            const name = this.point.name;

                            // Split by words into lines up to ~15 chars each
                            const words = name.split(' ');
                            let line = '';
                            const lines = [];

                            words.forEach(word => {
                                if ((line + word).length > 25) {
                                    lines.push(line.trim());
                                    line = word + ' ';
                                } else {
                                    line += word + ' ';
                                }
                            });

                            if (line) {
                                lines.push(line.trim());
                            }

                            return lines.join('<br/>') + `<a onclick="chartClicked(event, {id: ${this.point.node.id}, name: '${this.point.node.name}'})"><div class="highcharts-container__button" style="
                                    display: flex;
                                    align-items: center;
                                    background: #016d94 url(icon-clients-white.svg) no-repeat 10px 7px;
                                    background-size: 14px auto;
                                    padding: 2px 10px 0 32px; 
                                    margin-top: 5px;
                                    border-radius: 14px;
                                    color: #fff; 
                                    font: normal 14px/26px Overpass, sans-serif;
                                    text-transform: none;
                                    text-overflow: ellipsis;
                             ">${this.point.count} partnerships </div></a>`;
                        },

                        style: {
                            fontSize: '0.6em',
                            fontWeight: 'bold',
                            textTransform: 'uppercase',

                        },
                        borderRadius: 6,
                        padding: 3,

                    },
                }
            ],
            data: []
        }
    ],
    title: {
        text: null,
    },
    exporting: {
        enabled: false
    },
    tooltip: {
        useHTML: true,
        pointFormat: '<b style="font-size: 16px;font-weight: bold;line-height: normal;color: #3b3b3b;">{point.name}</b><br>\
                     <b style="margin-right: 16px;width: 100px;font-size: 16px;font-weight: bold;line-height: normal;color: #3b3b3b;">Market Size:</b> <span style="font-size: 16px;font-weight: normal;line-height: normal;color: #3b3b3b;">{point.amount}</span><br>\
                     <b style="margin-right: 16px;width: 100px;font-size: 16px;font-weight: bold;line-height: normal;color: #3b3b3b;">Partnerships:</b> <span style="font-size: 16px;font-weight: normal;line-height: normal;color: #3b3b3b;">{point.count}</span>',
        positioner: function(labelWidth, labelHeight, point) {
            var tooltipX = point.plotX - labelWidth / 2;
            var tooltipY = point.plotY - 100;
            return { x: tooltipX, y: tooltipY };
        }
    }
}
